import react from "react";
import muiTheme from "../../../../themes/muiTheme";
import { Box } from "@mui/material";

interface Props {
  isPortrait: boolean;
  viewWidth: number;
}

export const Divider = ({ isPortrait, viewWidth }: Props) => {
  return (
    <Box sx={{ py: 1.2 }}>
      <Box
        sx={{
          height: 1,
          width: !isPortrait ? 208 : viewWidth - 32,
          borderBottom: "1px solid",
          borderColor: muiTheme.palette.grey[200],
        }}
      />
    </Box>
  );
};
